import $ from 'jquery';
import Swiper from '../../node_modules/swiper/js/swiper.min.js';

$.addInit(function(context) {
	var base = '.b-product';
	
	$(base, context).each(function(){
		var component = $(this);

		var modal = $('#good').closest('.b-modal');
		var modalSlider = modal.find('.b-goodSlider');
		var productSlider = component.find('.b-product-slider .b-goodSlider');

		modal.on('show', function() {
			var idx = productSlider.data('goodSlider').realIndex;
			modalSlider.data('goodSlider').slideTo(idx, 0);
		});

		modal.on('open', function() {
			setTimeout(function() {
				modalSlider.data('goodSlider').update();
			});
		});
	});
});